export default "__VITE_ASSET__9c88884d__"